import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";

interface TaskHistoryTabProps {
	taskId: string;
}

export const TaskHistoryTab = ({ taskId }: TaskHistoryTabProps) => {
	const { history, loading, fetchHistory } = useHistoryOperations('task');

	// Fetch history when component mounts
	useEffect(() => {
		if (taskId) {
			fetchHistory(taskId);
		}
	}, [taskId, fetchHistory]);

	return (
		<div>
			<h3 className="text-lg font-semibold mb-4">Task History</h3>
			<EntityHistory history={history} loading={loading} />
		</div>
	);
};
